const config = {
  HOST_URL_Live_SSO: "https://fig.sso.id",
  SSO_ClientId: "yXdltQCCCzpPnYGofWncE",
  // SSO_ClientId: "jOVcjTphvHVnaOHbRGtWR",
  // API_HOST_URL_live: "https://localhost:7076",
  // API_HOST_URL_live: "http://figappapi.vidhaninfotech.com",
  // HOST_URL_live_clever: "http://thefigapp.vidhaninfotech.com",
  // API_CHAT_URL_live: "http://figappapi.vidhaninfotech.com/chathub",
  // isProduction: false,

  // API_HOST_URL_live: "https://test.figk-12.com",
  // HOST_URL_live_clever: "https://staging.figk-12.com",
  // API_CHAT_URL_live: "https://test.figk-12.com/chathub",
  // isProduction: false,

  API_CHAT_URL_live: "https://api.figk-12.com/chathub",
  API_HOST_URL_live: "https://api.figk-12.com",
  HOST_URL_live_clever: "https://figk-12.com",
  isProduction: true,

  // Scaffolded Azure SQL data API. The slug picks the database: "the" -> TheFigApp (prod),
  // "dev" -> TheFigAppDev. Defaults to "the" so nothing changes unless a build sets the env
  // var, and figdev is built with REACT_APP_DATA_SLUG=dev.
  //
  // New scaffold calls should go through Config.DATA_API. The ~13 existing call sites still
  // hardcode /api/the and are migrated separately, so they stay on prod for now.
  DATA_API_SLUG: process.env.REACT_APP_DATA_SLUG || "the",
  DATA_API: `https://azuresql.swancreate.com/api/${process.env.REACT_APP_DATA_SLUG || "the"}`,

  SAML_SSO_BASE: "https://saml.swancreate.com",
  SAML_TENANT_API: "https://figazuresql.swancreate.com/api/erp/saml_tenant",
  SAML_CALLBACK_PATH: "/auth/saml-callback",

  BITMOVIN_PLAYER_KEY: "946c4770-e0e4-40e2-9e61-e245a540cba7",

  // FIG CRM (sales.figk-12.com) integration for inbound web leads
  CRM_DATA_API: "https://figazuresql.swancreate.com/api/crm",
  CRM_LEADS_URL: "https://sales.figk-12.com/leads",
  SCHEDULING_GROUP_ID: "709CACB7-2D22-4F7F-AEC6-5EFB4696D46B",
  // Seeded from CRMGroupMembers.Scheduling — swap to dynamic lookup once
  // figazuresql re-scaffolds CRMGroupMembers route.
  SCHEDULING_RECIPIENTS: [
    { email: "dusty@swank12.com", name: "Dusty Swan" },
  ],

};

export default config